import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';
import { format } from 'date-fns';

export const routes = {
  lcDashboardQueriesPath: (vt, filterPinned) => `/api/CMSv2/LCDashboard/Queries?viewType=${vt}&filterPinned=${!!filterPinned}`,
  upsertLCDashboardQueriesDetailsPath: (bucketId) => `/api/CMSv2/LCDashboard/Details/${bucketId}`,
  executeQueryPath: (queryName) => `/api/CMSv2/LCDashboard/Execute/${queryName}`,
  actionQueryPath: (queryName) => `/api/CMSv2/LCDashboard/action/${queryName}`,
  lcDashboardSettingsPath: (userId) => `/api/CMSv2/LCDashboard/Settings/${userId}`,
  setLcDashboardSettingsPath: () => '/api/CMSv2/LCDashboard/Settings',
  getOrdersFiltersPath: () => '/api/CMSv2/LCDashboard/Filters/Orders',
  syncFiltersPath: () => '/api/CMSv2/LCDashboard/Filters/Sync',
  viewTypesPath: () => '/api/CMSv2/LCDashboard/ViewTypes',
  counts: (state, params) => `/api/CMSv2/LCDashboard/${state}/count${getQueryParams(params, { arrayFormat: 'repeat' })}`,
  pinnedCounts: (params) => `/api/CMSv2/LCDashboard/pinned/count${getQueryParams(params, { arrayFormat: 'repeat' })}`,
  emailNotice: () => '/api/onHoldBucket/action/emailOrganizationNoticeOnly',
  emailScheduledNoEquipment: () => '/api/ScheduledNoEquipmentBucket/action/email',
  auditsPath: (params) => `/api/CMSv2/LCDashboard/Queries/Audits${getQueryParams(params)}`,
  auditsUsersPath: () => '/api/CMSv2/LCDashboard/Queries/Audits/Users',
  auditsPropertiesPath: () => '/api/CMSv2/LCDashboard/Queries/Audits/Properties',
};

export const getLCDashboardQueries = (viewType, filterPinned) => makeRequest(authFetch.get(routes.lcDashboardQueriesPath(viewType, filterPinned)));
export const upsertLCDashboardQueries = (items) => makeRequest(authFetch.put(routes.lcDashboardQueriesPath(), items));
export const upsertLCDashboardQueriesDetails = (bucketId, data) => makeRequest(authFetch.put(routes.upsertLCDashboardQueriesDetailsPath(bucketId), data));
export const executeQuery = (queryName, filter, otherParams) => makeRequest(
  authFetch.post(routes.executeQueryPath(queryName), {
    filter: {
      ...filter,
      currentTime: filter.currentTime || format(new Date().toLocaleString('en-US'), 'YYYY-MM-DD HH:mm:ss'),
    },
    otherParams,
  }),
);
export const actionQuery = (queryName, data) => makeRequest(authFetch.post(routes.actionQueryPath(queryName), data));
export const getSettings = (userId) => makeRequest(authFetch.get(routes.lcDashboardSettingsPath(userId)));
export const setSetting = (setting) => makeRequest(authFetch.put(routes.setLcDashboardSettingsPath(), setting));
export const getOrdersFilters = () => makeRequest(authFetch.get(routes.getOrdersFiltersPath()));
export const syncFilters = (filtersIds) => makeRequest(authFetch.post(routes.syncFiltersPath(), { filtersIds }));
export const postEmailNoticeOnly = (data) => makeRequest(authFetch.post(routes.emailNotice(), data));
export const postEmailScheduledNoEquipment = (data) => makeRequest(authFetch.post(routes.emailScheduledNoEquipment(), data));
export const getLcDashboardViewTypes = () => makeRequest(authFetch.get(routes.viewTypesPath()));
export const getQueryCount = (state, filter) => makeRequest(authFetch.get(routes.counts(state, { currentTime: format(new Date().toLocaleString('en-US'), 'YYYY-MM-DD HH:mm:ss'), ...filter })));
export const getCountForPinned = (filter) => makeRequest(authFetch.get(routes.pinnedCounts({ currentTime: format(new Date().toLocaleString('en-US'), 'YYYY-MM-DD HH:mm:ss'), ...filter })));
export const getLcDashboardAudits = (params) => makeRequest(authFetch.get(routes.auditsPath(params)));
export const getLcDashboardAuditUsers = (params) => makeRequest(authFetch.get(routes.auditsUsersPath(params)));
export const getLcDashboardAuditProperties = (params) => makeRequest(authFetch.get(routes.auditsPropertiesPath(params)));
